import type { ReactNode } from "react";

/** Placeholder shapes that match the content they stand in for, so nothing jumps on load. */
export function Skeleton({ className = "", width, height }: { className?: string; width?: string; height?: string }) {
  // Sizes come from classes where possible; the few one-off sizes go through CSSOM (allowed
  // by our Content-Security-Policy, unlike style attributes in HTML).
  return (
    <span
      className={`skeleton ${className}`}
      aria-hidden="true"
      ref={(el) => {
        if (!el) return;
        if (width) el.style.width = width;
        if (height) el.style.height = height;
      }}
    />
  );
}

/** A labelled loading region: screen readers hear "Loading …" once, not every block. */
export function SkeletonRegion({ label, children, className = "" }: { label: string; children: ReactNode; className?: string }) {
  return (
    <div className={className} role="status" aria-label={label}>
      <span className="visually-hidden">{label}</span>
      {children}
    </div>
  );
}
